import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSlotStore } from "../store/useSlotStore";
import useOneToManySlotStore from "../store/useOneToManySlotStore";


const ClearAllStoresOnNavigate = () => {
    const location = useLocation();
  const {  removeSlot} = useSlotStore()
     const {     removeOneToManySlot} = useOneToManySlotStore()
    useEffect(() => {
        removeSlot()
     removeOneToManySlot()
    }, [location.pathname]);

    return null;
};

export default ClearAllStoresOnNavigate;
